import {RequestMethod, RequestOptionsArgs,  RequestOptions} from 'angular2/http';
import { HttpParams,   HttpRequest } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Http } from '@angular/http';

import { ActivatedRoute } from '@angular/router';

import 'rxjs/Rx';

import { APP_CONFIG } from '../app.config';
import { AuthService } from './auth.service';
import { Auth } from '../models/auth.model';

@Injectable()
export class StorageService {
  storagesChanged = new Subject<any[]>();
  storageChanged = new Subject<any>();
  storageOperation = new Subject<any>();

  storagesSubChanged = new Subject<any>();
  storageSubOperation = new Subject<any>();
  movestoragesChanged = new Subject<any>();
  movestoragesOperation = new Subject<any>();
  storageMigrateToS3 = new Subject<any>();
  storageMigrateToS3Support = new Subject();

  private storages = [];
  private subStorages = [];
  private moveStorages = [];

  public template_id = 0;

  constructor(@Inject(APP_CONFIG) private appConfig, private http: Http) {}

  setStorages(storages: any[]) {
    this.storages = storages;
    this.storagesChanged.next(this.storages.slice());
  }

  setSubStorages(subStorages: any[]) {
    this.subStorages = subStorages;
    this.storagesSubChanged.next(this.subStorages.slice());
  }

  setMoveStorages(moveStorages: any[]) {
    this.moveStorages = moveStorages;
    this.movestoragesChanged.next(this.moveStorages.slice());
  }

  getStorages() {
    return this.storages.slice();
  }

  getClient(id: number) {
    return this.storages[id];
  }

  httpGetStorages(type: string, id: number, params: any = {}) {
    let httpParams = new HttpParams();

    for (const p of Object.keys(params)) {
      httpParams = httpParams.append(p, params[p]);
    }

    let queryString = httpParams.toString();

    if (queryString) {
      queryString = '?' + queryString;
    }

    return this.http.get(
      this.appConfig.API_ENDPOINT + '/storages/' + type + '/' + id + queryString,
    )
    .map(
      (response: any) => {
        const storages: any = response.json();

        if (storages.status === 'success') {
          return storages.data;
        }

        return [];
      }
    )
    .subscribe(
      (response: any[]) => {
        this.setStorages(response);
      }
    );
  }

  httpGetSubStorages(type: string, id: number, params: any = {}) {

    let httpParams = new HttpParams();

    for (const p of Object.keys(params)) {
      httpParams = httpParams.append(p, params[p]);
    }

    let queryString = httpParams.toString();

    if (queryString) {
      queryString = '?' + queryString;
    }

    return this.http.get(
      this.appConfig.API_ENDPOINT + '/storages/' + type + '/' + id + queryString,
    )
    .map(
      (response: any) => {
        const storages: any = response.json();

        if (storages.status === 'success') {
          return storages.data;
        }

        return [];
      }
    )
    .subscribe(
      (response: any[]) => {
        this.setSubStorages(response);
      }
    );
  }

  httpGetMoveStorages(type: string, id: number, params: any = {}) {

    let httpParams = new HttpParams();

    for (const p of Object.keys(params)) {
      httpParams = httpParams.append(p, params[p]);
    }

    let queryString = httpParams.toString();

    if (queryString) {
      queryString = '?' + queryString;
    }

    return this.http.get(
      this.appConfig.API_ENDPOINT + '/storages/' + type + '/' + id + queryString,
    )
    .map(
      (response: any) => {
        const storages: any = response.json();

        if (storages.status === 'success') {
          return storages.data;
        }

        return [];
      }
    )
    .subscribe(
      (response: any[]) => {
        this.setMoveStorages(response);
      }
    );
  }

  httpPostStorage(data: any) {

    const formData = new FormData();

    const file = data['file'];

    if ( typeof file !== 'undefined' ) {
      for (let i = 0; i < data.file.length; i++) {
        formData.append('file[]', file[i], file[i].name);
      }
    }

    formData.append('name', data['name']);
    formData.append('type', data['type']);
    formData.append('path', data['path']);

    return this.http.post(
      this.appConfig.API_ENDPOINT + '/storages',
      formData
    )
    .map(
      (response: any) => {
        const storages: any = response.json();

        if (storages.status === 'success') {
          return storages.data;
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {

        this.storageOperation.next(response);
      }
    );
  }

  httpPostMigrateToS3(data: any) {
    const formData = new FormData();

    formData.append('file', data['file']);

    if ( data['support'] === 'yes' ) {
      formData.append('support', data['support']);
    } else {
      formData.append('template_id', data['template_id']);
      formData.append('client_id', data['client_id']);
    }

    return this.http.post(
      this.appConfig.API_ENDPOINT + '/storages/migrate',
      formData
    )
    .map(
      (response: any) => {
        if (typeof response._body !== 'undefined' && response._body != null) {
            return JSON.parse(response._body);
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        if ( response.data.type === 'editor' ) {
          this.storageMigrateToS3.next(response);
        }
        if ( response.data.type === 'support' ) {
          this.storageMigrateToS3Support.next(response);
        }
      }
    );
  }

  httpDeleteStorage(data: any) {

    const formData = new FormData();

    formData.append('type', data['type']);
    formData.append('path', data['path']);

    return this.http.post(
      this.appConfig.API_ENDPOINT + '/storages/delete',
      formData
    )
    .map(
      (response: any) => {
        const storages: any = response.json();

        if (storages.status === 'success') {
          return storages.data;
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.storageOperation.next(response);
      }
    );
  }

  httpMoveStorage(data: any) {

    const formData = new FormData();

    formData.append('type', data['type']);
    formData.append('path', data['path']);
    formData.append('move_to_path', data['move_to_path']);
    return this.http.post(
      this.appConfig.API_ENDPOINT + '/storages/move',
      formData
    )
    .map(
      (response: any) => {
        const storages: any = response.json();

        if (storages.status === 'success') {
          return storages.data;
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.storageOperation.next(response);
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/services/storage.service.ts